import { createRoot } from 'react-dom/client';

import App from './components/App';
import { Config } from './types';

window.NavigationBar = function (el, config: Config) {
    const root = createRoot(el);
    root.render(<App {...config} />);
};
